<div mat-dialog-title class="flex-roleplay dialog-header">
    <div class="float-left">
        <h2>Roleplay Feedback</h2>
    </div>
    <div class="float-right" (click)="onSkipClick()">
        <img src="../../../assets/images/roleplay/icon-dialog-close.svg" width="20" height="20" alt="Close dialog">
    </div>
</div>

<mat-dialog-content class="dialog-content">
    <form class="dialog-form" [formGroup]="feedbackForm" (ngSubmit)="onSubmit()">
        <div class="row">
            <div class="col-12">
                <label>How would you rate the experience of the roleplay? <span class="required">*</span></label>
                <div class="rate-card-wrapper">
                    @for(option of fields['rating']['options']; track option){
                    <div class="inner" (click)="onClickExperience(option)">
                        <span>{{option.label}}</span>
                        <div class="card" [ngClass]="{'active': feedbackForm.get('rating').value == option.value}">
                            {{option.value}}</div>
                    </div>
                    }
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-textarea [field]="fields['comment']" formControlName="comment"></app-textarea>
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="actions buttons-wrapper" align="end">
    <app-button [button]="skipButton" (clicked)="onSkipClick()"></app-button>
    <app-button [button]="submitButton" (clicked)="onSubmit()" [disabled]="!feedbackForm.valid"></app-button>
</mat-dialog-actions>